export default "nz-select {\n  margin-right: 8px;\n  width: 400px;\n}";